import { Alert } from '@mui/material'
import { ReactFlowProvider } from '@xyflow/react'
import { WorkflowDesigner } from '@features/adventures/components/workflow-designer'
import type { SectionId } from '../AdventureRibbon'

interface WorkflowDesignerPanelProps {
  adventureId: string
  // Editor ribbon props for mobile hamburger menu
  editorMenuProps?: {
    activeSection: SectionId
    onSectionChanged: (section: SectionId) => void
    onEditorSave?: () => void
    onPublish?: () => void
    onDelete?: () => void
    isEditorSaving?: boolean
    isPublishing?: boolean
    isReadyToPublish?: boolean
  }
}

export function WorkflowDesignerPanel({ adventureId, editorMenuProps }: WorkflowDesignerPanelProps) {
  if (!adventureId) {
    return (
      <Alert severity="warning">
        Please save the adventure first before creating a workflow.
      </Alert>
    )
  }

  return (
    <ReactFlowProvider>
      <div style={{ height: '100%', width: '100%' }}>
        <WorkflowDesigner adventureId={adventureId} editorMenuProps={editorMenuProps} />
      </div>
    </ReactFlowProvider>
  )
}
